import React, { ReactNode } from 'react';

import {
  Amazon,
  Apple,
  Baidu,
  BattleNet,
  ChinaTelecom,
  Discord,
  EpicGames,
  Facebook,
  GitHub,
  Google,
  GooglePlus,
  Instagram,
  Kabam,
  KakaoTalk,
  LinkedIn,
  MailRu,
  Microsoft,
  MSN,
  Naver,
  OK,
  Paradox,
  PayPal,
  Pinterest,
  QQ,
  Reddit,
  Steam,
  Twitch,
  Vimeo,
  VK,
  WarnerBrothers,
  WeChat,
  Weibo,
  X,
  Xbox,
  Xsolla,
  XsollaId,
  Yahoo,
  Yandex,
  YouTube
} from '../../../../assets';

type List = {
  [key: string]: ReactNode | undefined;
};

export const SocialIconsList: List = {
  google: <Google />,
  apple: <Apple />,
  epicgames: <EpicGames />,
  amazon: <Amazon />,
  babka: <Xsolla />,
  'xsolla-id': <XsollaId />,
  battlenet: <BattleNet />,
  baidu: <Baidu />,
  china_telecom: <ChinaTelecom />,
  discord: <Discord />,
  facebook: <Facebook />,
  github: <GitHub />,
  'google+': <GooglePlus />,
  instagram: <Instagram />,
  kabam: <Kabam />,
  kakao: <KakaoTalk />,
  linkedin: <LinkedIn />,
  mailru: <MailRu />,
  microsoft: <Microsoft />,
  msn: <MSN />,
  naver: <Naver />,
  ok: <OK />,
  paradox: <Paradox />,
  paypal: <PayPal />,
  pinterest: <Pinterest />,
  wbgames: <WarnerBrothers />,
  qq: <QQ />,
  reddit: <Reddit />,
  steam: <Steam />,
  twitch: <Twitch />,
  twitter: <X />,
  vimeo: <Vimeo />,
  vk: <VK />,
  wechat: <WeChat />,
  weibo: <Weibo />,
  xbox: <Xbox />,
  yahoo: <Yahoo />,
  yandex: <Yandex />,
  youtube: <YouTube />
};
